export default "__VITE_ASSET__$G3RSRO4__"